export const convertToSeconds = (cancelBefore, cancelationWindowUnit) => {
  const cancelBeforeValue = parseInt(cancelBefore, 10);
  let seconds = 0;

  if (cancelationWindowUnit === "d") {
    seconds = cancelBeforeValue * 24 * 60 * 60; // days to seconds
  } else if (cancelationWindowUnit === "h") {
    seconds = cancelBeforeValue * 60 * 60; // hours to seconds
  }

  return seconds;
};
export const decodeJWT = (jwt) => {
  // Split the token into parts
  const parts = jwt.split(".");

  if (parts.length !== 3) {
    console.error("Invalid JWT format");
    return null;
  }

  // Take the payload (middle part)
  const payload = parts[1];

  // Replace characters for Base64Url to Base64
  const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");

  // Decode the Base64 string
  const decodedString = atob(base64);

  // Parse the JSON
  return JSON.parse(decodedString);
};
export const validatePtGroupPricing=({pricingType="tiered",extraPersonFee,price,capacity,tiers=[]})=>{
     if(pricingType === "static") {
        // Validate extraPersonFee is provided
        if(!extraPersonFee || extraPersonFee <= 0) {
          return {valid:false,reason:"Extra Person Fee is required and must be greater than 0"};
        }
         return {valid:true,reason:""};
      } else if(pricingType === "tiered") {
        // Validate tiered pricing
        if(!tiers || tiers.length === 0) {
           return {valid:false,reason:"Tiered pricing configuration is required"};
        }
        
        // Validate all tiers have prices set
        const invalidTiers = tiers.filter(tier => 
          tier.price === null || tier.price === undefined || tier.price < 0||tier.price===0
        );
        
        if(invalidTiers.length > 0) {
          return {valid:false,reason:"All tier prices must be set and cannot be negative"};

        }
        
        // Validate tiers array matches capacity
        if(tiers.length !== capacity) {
          return {valid:false,reason:`Tiers configuration must match capacity (${capacity} players)`};

        }
        
        // Optional: Validate first tier matches base price
        if(tiers[0].price !== price) {
          return {valid:false,reason:"First tier price must match the base price"};

        }
        return {valid:true,reason:""};

      }else {
        return {valid:false,reason:"Please select a pricing type"};
      }
}
export const generatePtGroupTiersObj=({pricingType="tiered",extraPersonFee,price,capacity,tiers=[]})=>{
  const {valid,reason}=validatePtGroupPricing({pricingType,extraPersonFee,price,capacity,tiers})
  if(!valid) return {valid,reason,tiers:[]}
  if(pricingType === "static") {
      // Generate tiers for static pricing
      const newTiers = [{players: 1, price: price}];
      for (let i = 2; i <= capacity; i++) {
        newTiers.push({
          players: i,
          price: price + ((i - 1) * extraPersonFee),
        });
      }
      return {valid,reason,tiers:newTiers};
      
    } 
    return {valid,reason,tiers};  
    
}